import React from 'react';
//import { Link } from 'react-router-dom';
import './hyacinth.css';



const Silwanehyacinth = () => {

    /*
    <div className="silwanehyacinthbutton">
                <p>Learn More</p>
            </div>

    */
  
  return (
    <>
    <div className="silwamehyacinthcont">

        <div className="hyacinthimgcont">
            <img src="https://optimize.sirv.com/silwane/hyacinth.jpg" alt="silwanefalls" />
        </div>

        <div className='silwanehyacinthintro'>
            <div className='silwanehyacinthparasecti'>
                <h2>Hyacinth in the Dam</h2>
                <p>The Silwane Nature Reserve dam, while a vital part of our ecosystem and a beautiful feature, is periodically affected by the presence of Water Hyacinth</p>
                <p>This invasive aquatic plant sometimes experiences rapid growth, forming dense, floating mats that can completely cover sections of the dam's surface. While we manage this issue continuously, high growth periods can significantly impact our dam activities.</p>
            </div>
            
        </div>
      
    </div>

    
   
    </>
  );
};
  
export default Silwanehyacinth;
  